<template>
  <div id="error404" class="flex-align">
    <a-result status="error" title="抱歉，认证未通过" sub-title="请确认认证人员与法人/董事证件中人员一致。并扫码重新认证。" />
  </div>
</template>
<style lang="less" scoped>
#error404 {
  justify-content: center;
  height: 100vh;
}
</style>

